__turbopack_context__.v({
  "card": "v_jTyG_card",
  "cardContent": "v_jTyG_cardContent",
  "cardSubtitle": "v_jTyG_cardSubtitle",
  "cardTitle": "v_jTyG_cardTitle",
  "ctaRow": "v_jTyG_ctaRow",
  "grid": "v_jTyG_grid",
  "image": "v_jTyG_image",
  "imageWrap": "v_jTyG_imageWrap",
  "insetBorder": "v_jTyG_insetBorder",
  "primaryCta": "v_jTyG_primaryCta",
  "section": "v_jTyG_section",
  "stepBadge": "v_jTyG_stepBadge",
  "title": "v_jTyG_title",
});
